@if (exportStatus.status$ | async; as status) {
  @if (status === 'generating') {
    <div
      class="c-export-banner c-export-banner--generating c-export-banner--enter"
      role="status"
      aria-live="polite"
      aria-busy="true">
      <span class="c-export-banner__spinner" aria-hidden="true"></span>
      <span>Preparing your export…</span>
    </div>
  } @else if (status === 'ready') {
    <div class="c-export-banner c-export-banner--ready c-export-banner--enter" role="status" aria-live="polite">
      <span class="c-export-banner__icon" aria-hidden="true">✓</span>
      <span>Download ready</span>
      <button type="button" class="c-export-banner__link" (click)="onRedownload()">Download again</button>
    </div>
  } @else if (status === 'error') {
    <div class="c-export-banner c-export-banner--error c-export-banner--enter" role="alert" aria-live="assertive">
      <span>Export failed. Try again.</span>
      <button type="button" class="c-export-banner__link" (click)="onRetry()">Retry</button>
    </div>
  }
}
